var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column min-vh-100",attrs:{"id":"app"}},[(
      _vm.$route.name != 'SignIn' &&
        _vm.$route.name != 'Register' &&
        _vm.$route.name != 'ForgottenPassword'
    )?_c('Header'):_vm._e(),(
      _vm.$route.name == 'SignIn' ||
        _vm.$route.name == 'Register' ||
        _vm.$route.name == 'ForgottenPassword'
    )?_c('HeaderAuth'):_vm._e(),_c('div',{staticClass:"kotha-default-content flex-fill"},[_c('router-view',{key:_vm.$route.fullPath})],1),(
      _vm.$route.name != 'SignIn' &&
        _vm.$route.name != 'Register' &&
        _vm.$route.name != 'ForgottenPassword'
    )?_c('Footer'):_vm._e(),_c('MobileAppMenu'),(_vm.updateExists && _vm.isPWA)?_c('div',{staticClass:"update-dialog"},[_c('div',{staticClass:"update-dialog__content"},[_vm._v(" Na voljo je nova različica aplikacije. ")]),_c('div',{staticClass:"update-dialog__actions"},[_c('button',{staticClass:"btn btn-success mt-2",on:{"click":_vm.refreshApp}},[_vm._v(" Posodobi ")])])]):_vm._e(),_c('cookie-law',{attrs:{"buttonText":'Strinjam se'}},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v(" Spletno mesto uporablja piškotke, s katerimi izboljšujemo uporabniško izkušnjo in zagotavljamo vsebine. "),_c('router-link',{attrs:{"to":{
                    name: 'TermsAndConditions',
                  hash: '#politika-piskotkov'
                  }}},[_vm._v("Več")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }